module.exports = __webpack_public_path__ + "img/Stocksy_Delivery_signature.62fb798f.jpg";